import { createSvgIcon } from '@mui/material/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var LevelUpIcon = createSvgIcon( /*#__PURE__*/_jsxs(_Fragment, {
  children: [/*#__PURE__*/_jsx("path", {
    d: "M17.79,9H15v6H9V9H6.2a.49.49,0,0,1-.35-.84l5.8-5.8a.5.5,0,0,1,.71,0l5.79,5.78A.51.51,0,0,1,17.79,9Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M9,19h6a0,0,0,0,1,0,0v.5a.5.5,0,0,1-.5.5h-5a.5.5,0,0,1-.5-.5V19A0,0,0,0,1,9,19Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "9",
    y: "15.97",
    width: "6",
    height: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18,21h2a0,0,0,0,1,0,0v.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V21A0,0,0,0,1,18,21Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M18.82,15.15l-2.4,2.4a.25.25,0,0,0,.18.42h4.8a.25.25,0,0,0,.17-.43l-2.39-2.39A.25.25,0,0,0,18.82,15.15Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "18",
    y: "17.97",
    width: "2",
    height: "2"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4,18H6a0,0,0,0,1,0,0v.5a.5.5,0,0,1-.5.5h-1a.5.5,0,0,1-.5-.5V18A0,0,0,0,1,4,18Z"
  }), /*#__PURE__*/_jsx("path", {
    d: "M4.82,12.15l-2.4,2.4A.25.25,0,0,0,2.6,15H7.4a.25.25,0,0,0,.17-.43L5.18,12.15A.25.25,0,0,0,4.82,12.15Z"
  }), /*#__PURE__*/_jsx("rect", {
    x: "4",
    y: "14.97",
    width: "2",
    height: "2"
  })]
}), 'LevelUpIcon');